<template>
  <div class="my-layout-box">
    <!-- 基本信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>基本信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>合同编号： </span>
            <i class="c-code-color">{{item.ContractNo}}</i>
          </li>
          <li>
            <span>入仓单号:</span>
            <i class="c-two-color"> {{item.AgentOrderNos}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>供方: </span>
            <i>深圳市正能量供应链服务有限公司</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>需方: </span>
            <i>{{item.Demander}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>签订地点: </span>
            <i>深圳</i>
          </li>
          <li>
            <span>签约时间: </span>
            <i>{{item.SignDate | formatDate}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>备注: </span>
            <i>{{item.Remark}}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 公司信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>供方代需方向其指定的生产商采购下列货物，为明确双方权利 义务、现订立本合同如下：</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>

      </section>
    </section>

  </div>
</template>
<script>
import { getOrderContractDetail  } from "~/api/finance";
import { itemsDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
export default {
  name: "orderContractDetail",
  components: {
    DetailList
  },
  data() {
    return {
      item: {},
      listMap: itemsDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        ContractId: id
      };
      let data = await getOrderContractDetail(params);
      this.item = data
      this.$refs.detailList.getList(data.ContractLines);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>

